import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import InitPage     from "./pages/InitPage";
import CheckoutPage from "./pages/CheckoutPage/CheckoutPage";
import ResponsePage from "./pages/ResponsePage/ResponsePage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"              element={<InitPage     />} />
        <Route path="/pay/*"          element={<CheckoutPage />} />
        <Route path="/response-page" element={<ResponsePage />} />
      </Routes>
    </Router>
  );
}

export default App;
